import {Validation} from "@/data/Validation";
import {FulfillmentType} from "@/data/entities/restaurant";
import dishPlaceholderSvg from "@/assets/img/menu/dish-placeholder.svg";

export const productPlaceholderImgSrc: string = dishPlaceholderSvg;

export type FeaturedProductDetails = {
    id: number,
    description: string,
    orderNumber: number,
    productExternalId: string,
    product: ProductReference | null,
    creationDate: string, // OffsetDateTime
};

export type ProductReference = {
    id: number,
    externalId: string,
    name: string,
    price: number,
    priceTakeaway: number,
    categoryNames: string[],
};

export type FeaturedProductFormValues = {
    description: string,
    orderNumber: number,
    productId: number | null, // `null` if product doesn't exist (anymore)
};

export type PlacedOrderProduct = {
    name: string;
    price: number;
    deposit: number;
    vat: number;
    supFee: number;
    count: number;
    image: string | null;
    redeemedLoyaltyPoints: number | null;
    options: PlacedOrderProductOption[];
};

export type PlacedOrderProductOption = {
    groupName: string;
    name: string;
    price: number;
    deposit: number;
    vat: number;
    supFee: number;
};

export const featuredProductFormValuesFormValidation: Validation<FeaturedProductFormValues> = {
    description: {
        required: true,
        minLength: 1,
        maxLength: 1024,
    },
    orderNumber: {
        required: true,
    },
    productId: {
        required: true,
    },
}

export type AddToCartProductSideDish = {
    externalId: string,
    optionGroupExternalId: string,
};

export type AddToCartProduct = {
    externalId: string,
    count: number,
    loyaltyRewardId: number | null,
    sideDishes: AddToCartProductSideDish[],
};

export type MatchingFulfillmentType = {
    match: boolean,
    // Only set if `match` is `false`, to contain the fulfillment type is does
    // match for:
    otherType: FulfillmentType | null,
};
